import { React, useState } from "react";
import AdminDashboardLayout from "../../../layout/AdminDashboardLayout";
import { DashboardWrapper } from "../../dashboard/dashboard.styled";
import { IntroductionHeader } from "../../dashboard/Dashboard";
import FormAccordion from "../../../components/Form/FormAccordion";
import { AddproductWrapper } from "../../Products/ProductsPage.styled";
import { AddContentTemplate } from "../Education.styled";
import NoticeBar from "../Partials/NoticeBar";
import {
	InputField,
	TextAreaField,
} from "../../../components/Form/FormComponents";
import { AiOutlineSave } from "react-icons/ai";
import { ImCancelCircle } from "react-icons/im";
import {
	ButtonGroup,
	CustomButton,
} from "../../Products/Forms/ProductForm.styled";
import { useNavigate } from "react-router";
import SingleContent from "../Partials/SingleContent";
import { UploadOutlined } from "@ant-design/icons";
import { Button, Upload } from "antd";
import Parse from "../../../api/ApiConfig";
import { toast } from "react-toastify";
import Switch from "@mui/material/Switch";
import { contentProps, generateId, formatDuration } from "../utils";
import { Capitalize } from "../../Products/ProductUtils/CategoriesUtils";
import { useDispatch } from "react-redux";
import { setLoadingState } from "../../../redux/AppSlice";

function AddAudio() {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [chapters, setChapters] = useState([]);
	const [formData, setFormData] = useState({});
	const [audioSrc, setAudioSrc] = useState("");
	const [checked, setChecked] = useState(false);
	const [isChapterActive, setChapterActive] = useState(false);
	const [duration, setDuration] = useState();
	const [thumbnailUrl, setThumbnailUrl] = useState("");
	const [isThumbnailSaved, setIsThumbnailSaved] = useState(false);
	const [isAudioSaved, setIsAudioSaved] = useState(false);

	const handleToggle = (e) => {
		//display chapters if toggle is set to true
		if (e.target.checked) {
			setChapterActive(true);
			createChapterTemplate();
			setFormData({ ...formData, link: "" }); //remove url once you activate chapters
			setIsAudioSaved(false);
			setDuration("");
			// setIsThumbnailSaved(false);
		}
		//hide chapter sections
		else {
			setAudioSrc("");
			// setThumbnailUrl("");
			setChapters([]);
			setChapterActive(false);
		}
		setChecked(e.target.checked);
	};

	//upload audio
	const onChange = (info) => {
		if (info.file.status !== "done") {
			const url = URL.createObjectURL(info?.file);
			setAudioSrc(url);
			saveContentToParse(info); //set actual upload file to parse
		}
	};
	const beforeUpload = (file) => {
		const url = URL.createObjectURL(file);
		setAudioSrc(url);
		return false;
	};
	const handleLoadedMetadata = (e) => {
		setDuration(e.target.duration);
	};

	//create new template
	const createChapterTemplate = () => {
		setChapters((oldData) => [
			...oldData,
			{
				name: "",
				description: "",
				link: "",
				chapter: "",
				coverPhoto: "",
				id: generateId(),
			},
		]);
	};

	//handle video without chapters
	const handleAudioData = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const saveContentToParse = async (data) => {
		dispatch(setLoadingState(true));
		try {
			const sanitizedFileName = data?.file.name.replace(/[^\w.-]+/g, "");
			const ContentFile = new Parse.File(sanitizedFileName, data?.file);
			// console.log(ContentFile);
			await ContentFile.save();
			console.log(ContentFile?._url);
			setFormData({ ...formData, link: ContentFile?._url }); //save audio url on upload of an audio
			toast.success("Audio saved successfully");
			setIsAudioSaved(true);
			dispatch(setLoadingState(false));
		} catch (error) {
			dispatch(setLoadingState(false));
			console.log(error);
			toast.error("unable to save audio file, please try again later");
			console.error("Error saving item:", error);
		}
	};

	const getChaptersDuration = () => {
		let sum = 0;
		for (let i = 0; i <= chapters.length - 1; i++) {
			sum += parseInt(chapters[i].duration);
		}
		return sum;
	};

	//save data to db
	const uploadContent = (e) => {
		console.log(chapters.length);
		console.log(getChaptersDuration());
		// console.log(chapters)
		e.preventDefault();
		if (!checked && !audioSrc) {
			toast.error("please ensure you upload an audio file");
			return;
		}
		if ((!checked && !thumbnailUrl) || (checked && !isThumbnailSaved)) {
			toast.error("please ensure you upload the audio thumbnail");
			return;
		}

		if (checked && chapters.length > 0) {
			let areDetailsFilled = true;
			for (let i = 0; i <= chapters.length - 1; i++) {
				if (!chapters[i].link || !chapters[i].coverPhoto) {
					toast.error(
						"seems like you activated the chapters section, please ensure you upload an audio file and a thumbnail for each chapter"
					);
					areDetailsFilled = false;
					break;
				}
			}
			if (!areDetailsFilled) {
				return;
			}
		}
		dispatch(setLoadingState(true));
		console.log(getChaptersDuration());
		const Education = Parse.Object.extend("Education");
		const education = new Education();
		education
			.save({
				...formData,
				courseType: "audio",
				chapters: chapters,
				category: Capitalize(formData?.category),
				totalDuration: duration
					? formatDuration(duration)
					: formatDuration(getChaptersDuration()),
			})
			.then(
				// eslint-disable-next-line no-unused-vars
				(prod) => {
					dispatch(setLoadingState(false));
					toast.success(
						"Content updated successfully, check table to see updated list"
					);
					navigate("/education/audio");
				},
				(error) => {
					console.log(error);
					dispatch(setLoadingState(false));
					toast.error("An error occured while uploading the audio file");
				}
			);
	};

	const thumbnailUpload = (e) => {
		const file = e.target.files[0];
		const reader = new FileReader();
		reader.onload = () => {
			setThumbnailUrl(reader.result);
		};
		if (file) {
			// console.log(file)
			reader.readAsDataURL(file);
			saveImageToParse(file);
		}
	};

	const saveImageToParse = async (file) => {
		dispatch(setLoadingState(true));
		try {
			const sanitizedFileName = file.name.replace(/[^\w.-]+/g, "");
			const imageFile = new Parse.File(sanitizedFileName, file);
			await imageFile.save();
			setFormData({ ...formData, coverPhoto: imageFile?._url }); //save image url on uploaded thumbnail
			dispatch(setLoadingState(false));
			toast.success("Audio thumbnail Saved");
			setIsThumbnailSaved(true);
		} catch (error) {
			dispatch(setLoadingState(false));
			toast.error("unable to audio thumbnail, please try again later", error);
			console.error("Error saving item:", error);
		}
	};

	{
		/* eslint-disable no-mixed-spaces-and-tabs  */
	}
	return (
		<AdminDashboardLayout>
			<DashboardWrapper>
				<IntroductionHeader nav={true} />
				<AddproductWrapper className='mt-10'>
					<FormAccordion title='Upload Audio Content' open={true}>
						<AddContentTemplate>
							<div className='leftSection'>
								<NoticeBar
									text={
										"You can create your audio with a single or in chapters, activate the chapter to start uploading content in chapters"
									}
								/>
							</div>

							<form onSubmit={uploadContent} className='RightSection'>
								<div className='form-group'>
									<label>TITLE</label>
									<InputField
										name='name'
										isEditable={true}
										handleChange={handleAudioData}
										value={formData?.name}
										required={true}
									/>
								</div>

								<div className='form-group'>
									<label>CATEGORY</label>
									<InputField
										name='category'
										isEditable={true}
										handleChange={handleAudioData}
										value={formData?.category}
										required={true}
									/>
								</div>

								<div className='form-group'>
									<label>DESCRIPTION</label>
									<TextAreaField
										name='description'
										isEditable={true}
										handleChange={handleAudioData}
										value={formData?.description}
										required={true}
									/>
								</div>
								{/* hide uploading of single content when chapters is activated */}
								{isChapterActive ? null : (
									<>
										<div className='form-group'>
											<label>UPLOAD SINGLE AUDIO</label>
											<Upload
												beforeUpload={beforeUpload}
												onChange={onChange}
												{...contentProps}
												accept='audio/*'
											>
												<Button
													style={{ color: "#959595", fontSize: "1rem" }}
													icon={
														<UploadOutlined style={{ fontSize: "1.2rem" }} />
													}
												>
													Click to upload
												</Button>
											</Upload>
										</div>

										{/* //display preview when user uploads a file */}
										{isAudioSaved ? (
											<audio
												autoPlay={false}
												controls
												src={audioSrc}
												onLoadedMetadata={handleLoadedMetadata}
											>
												<source src={audioSrc} type='audio/mpeg' />
												<source src={audioSrc} type='audio/ogg' />

												<p>
													Your browser doesnt support HTML audio. Here is a
													<a href={audioSrc}>link to the audio</a> instead.
												</p>
											</audio>
										) : null}
									</>
								)}

								<div className='form-group'>
									<label htmlFor='image'>ADD AUDIO THUMBNAIL</label>

									<label className='thumbnail_label' htmlFor='image'>
										<UploadOutlined style={{ fontSize: "1.2rem" }} /> Click to
										upload
										<input
											type='file'
											accept='image/*'
											name='image'
											id='image'
											onChange={thumbnailUpload}
										/>
									</label>
								</div>

								{isThumbnailSaved ? (
									<img
										className=''
										style={{ objectFit: "contain", height: "20rem" }}
										alt='audio thumbnail'
										src={thumbnailUrl}
									/>
								) : null}

								<div className='addChapter mt-10 space-between'>
									<div className='flex gap-2'>
										Chapters
										<Switch
											checked={checked}
											onChange={handleToggle}
											inputProps={{ "aria-label": "controlled" }}
										/>
									</div>
								</div>

								{chapters.length > 0
									? chapters.map((data, index) => {
											return (
												<SingleContent
													singleChapterData={data}
													chapters={chapters}
													setChapters={setChapters}
													createChapterTemplate={createChapterTemplate}
													key={index}
													index={index}
													type={"audio"}
												/>
											);
									  })
									: null}

								<ButtonGroup>
									<CustomButton
										type='submit'
										color='#ffffff'
										backgroundcolor='#003A50'
										// onClick={uploadContent}
									>
										<AiOutlineSave size={24} />
										{checked ? (
											<p>Upload all chapters</p>
										) : (
											<p>Upload content</p>
										)}
									</CustomButton>

									<CustomButton
										onClick={() => navigate("/education/audio")}
										type='button'
										backgroundcolor='#FF7878'
										color='#ffffff'
									>
										<ImCancelCircle size={24} />
										<p>Cancel</p>
									</CustomButton>
								</ButtonGroup>
							</form>
						</AddContentTemplate>
					</FormAccordion>
				</AddproductWrapper>
			</DashboardWrapper>
		</AdminDashboardLayout>
	);
}

export default AddAudio;
